import RecargoManagementPage from '../pages/RecargoManagementPage'

const routes = [
    { name: 'RecargoManagementPage', path: '/recargo-management', component: RecargoManagementPage },
]

export default routes;
